import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
// import { RegionModel } from '../models/region';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Injectable({
  providedIn: 'root'
})
export class ChannelProvider {

  actionSuccess:boolean = false;
  channels = []
  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration
    ) {
  }

  getAllChannels():void {
    this.apiService.getHeaders(this.apiConfig.configGetChannel)
      .subscribe((res: any) => {
        this.channels = res.body.data.all_channels;
      }, err => {
        console.log(err);
      })
  }

}
  // let updatedRegions =this.regions.splice(updateIndex, 1);
